import { render, staticRenderFns } from "./PosthogEventsStats.vue?vue&type=template&id=5e67156b"
import script from "./PosthogEventsStats.vue?vue&type=script&lang=js"
export * from "./PosthogEventsStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports